import { updateEverExpanded } from './index';
import serverApi from '../services/serverApi';
import { isExperimentOn } from '../reducers';
import { Experiments } from '../constants/experiments';

export const firstExpand = () => {
  return async function (dispatch, getState) {
    if (!getState().everExpanded) {
      dispatch(updateEverExpanded(true));
      await serverApi.reportFirstExpand(getState().allowInput);
      await serverApi.reportChatWidgetOpen();
    }
  };
};
